import React from "react";
import { FilterTypeShortRenderer } from "./FilterTypes";
import "./ProductFilters.scss";

export default function FilterLenta({
  filters = [],
  values = {},
  onChange,
  onChangeCategory
}) {
  function handleFilterChange(key, nextValue) {
    onChange({
      ...values,
      [key]: nextValue
    });
  }

  return (
    <div className="filter-lenta">
      {filters.map(filter => (
        <FilterTypeShortRenderer
          key={filter.key}
          filter={filter}
          value={values[filter.key]}
          onChangeCategory={onChangeCategory}
          onChange={(next) =>
            handleFilterChange(filter.key, next)
          }
        />
      ))}
    </div>
  );
}
